module.exports = __webpack_public_path__ + "static/media/C_7.a83eac8f.png";